import { FC } from "react";

interface LockIconSVGProps {
    className?: string;
}

const LockIconSVG: FC<LockIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.83333 13.8346V9.83464C9.83333 8.06653 10.5357 6.37083 11.786 5.12059C13.0362 3.87035 14.7319 3.16797 16.5 3.16797C18.2681 3.16797 19.9638 3.87035 21.214 5.12059C22.4643 6.37083 23.1667 8.06653 23.1667 9.83464V13.8346M17.8333 21.8346C17.8333 22.571 17.2364 23.168 16.5 23.168C15.7636 23.168 15.1667 22.571 15.1667 21.8346C15.1667 21.0983 15.7636 20.5013 16.5 20.5013C17.2364 20.5013 17.8333 21.0983 17.8333 21.8346ZM7.16667 13.8346H25.8333C27.3061 13.8346 28.5 15.0285 28.5 16.5013V27.168C28.5 28.6407 27.3061 29.8346 25.8333 29.8346H7.16667C5.69391 29.8346 4.5 28.6407 4.5 27.168V16.5013C4.5 15.0285 5.69391 13.8346 7.16667 13.8346Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LockIconSVG;
